import styled from 'styled-components'
import {
  BETREPLY_ELEMENTS_STYLED_PROPS,
  REPLY_WRAPPER_PROPS,
} from './interface'

export const ReplyWrapper = styled.div<REPLY_WRAPPER_PROPS>`
  padding: 31px 25px 7px;
  background: ${({ infoBoxBackgroundColor }) =>
    infoBoxBackgroundColor || 'rgba(0, 0, 0, 0.1)'};
  border-radius: 12px;
  width: 316px;
  /* height: 216px; */
  margin-bottom: 31px;
`
export const Reply = styled.div<BETREPLY_ELEMENTS_STYLED_PROPS>`
  h3 {
    font-weight: 700;
    font-style: normal;
    line-height: 16px;
    font-size: ${({ size }) => size || '16px'};
    color: ${({ majorTextColor }) => majorTextColor || '#C7C7C7'};
  }
  p {
    font-family: 'GT America, regular';
    padding-bottom: 24px;
    word-break: break-all;
    user-select: text;
    color: ${({ minorTextColor }) => minorTextColor || '#FFB000'};

    /* font-family: GT America; */
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
  }
  textarea {
    font-family: 'GT America, regular';
    background: transparent;
    color: ${({ textAreaColor }) => textAreaColor || '#C7C7C7'};
    border: none;
    outline: none;
    color: transparent;
    font-size: 18px;
    margin: auto;
    appearance: none;
    cursor: copy;
    text-shadow: 0 0 0 ${({ colors }) => colors};
    width: 100%;
    max-width: 500px;
    resize: none;
    user-select: text !important;
    line-height: 1.4;
    scrollbar-width: none;
    margin: 5px 0 22px;
    ::selection {
      background: none;
      border: none;
      :-moz-focus-inner {
        border: none;
        outline: none;
      }
    }
  }
`
